// src/pages/ConsoleSelection.js
import React from 'react';
import { Link } from 'react-router-dom';
import { SiPlaystation, SiNintendo } from 'react-icons/si';
import { FaXbox, FaWrench } from 'react-icons/fa'; // Keeping FaXbox as Si equivalent might be less common

// --- Styles (Consistent with other selection pages) ---
const contactLinkStyle = {
    display: 'inline-block', alignItems: 'center', background: '#6c757d', color: '#fff',
    border: '1px solid #6c757d', borderRadius: '4px', padding: '0.5rem 1rem',
    cursor: 'pointer', fontSize: '0.9rem', textDecoration: 'none', fontWeight: '500',
    transition: 'background-color 0.2s, border-color 0.2s', marginLeft: '4px',
};
const gridStyle = {
    display: 'flex', justifyContent: 'center', flexWrap: 'wrap',
    gap: '2rem', marginBottom: '3rem',
};
const consoleItemStyle = {
    display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '1.5rem',
    border: '1px solid #ccc', borderRadius: '8px', textDecoration: 'none', // Lighter border
    color: '#6c757d', // Dark grey text
    minWidth: '200px', textAlign: 'center',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)', backgroundColor: '#fff',
};
const logoContainerStyle = { marginBottom: '1rem', height: '60px', display: 'flex', alignItems: 'center', }; // Adjusted height slightly
const itemHeadingStyle = { margin: '0.5rem 0', fontSize: '1.2rem', color: '#6c757d', }; // Black heading
const itemTextStyle = { fontSize: '0.9rem', color: '#6c757d', }; // Grey text
const extraInfoStyle = {
    marginTop: '3rem', padding: '2rem', backgroundColor: '#f8f9fa',
    border: '1px solid #e0e0e0', borderRadius: '8px', textAlign: 'center', // Slightly softer border/bg
    maxWidth: '650px', marginLeft: 'auto', marginRight: 'auto', color: '#6c757d',
};
// --- ---

// --- Brand Data ---
const consoleBrands = [
    { name: 'PlayStation', path: '/console/playstation', Icon: SiPlaystation, ariaLabel: 'Select Sony PlayStation' },
    { name: 'Xbox', path: '/console/xbox', Icon: FaXbox, ariaLabel: 'Select Microsoft Xbox' },
    { name: 'Nintendo', path: '/console/nintendo', Icon: SiNintendo, ariaLabel: 'Select Nintendo Console' },
];
// --- ---

function ConsoleSelection() {
  return (
    // Use main, header, section for semantics. Assume page-container class exists or manage padding here.
    <main className="page-container console-selection-page" style={{ padding: '2rem 1rem' }}>
      <header style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
        <h1 style={{ fontSize: '2rem', color: '#6c757d', marginBottom: '0.5rem' }}>Select Your Gaming Console</h1>
        <p style={{ fontSize: '1.1rem', color: '#6c757d' }}>Choose your console brand to see supported models.</p>
      </header>

      {/* Use className for CSS grid is better, but using inline flex for now */}
      <div className="console-grid" style={gridStyle}>
        {consoleBrands.map((brand) => (
          <Link
            key={brand.name}
            to={brand.path}
            className="console-item" // Class for potential CSS overrides/hovers
            style={consoleItemStyle}
            title={`View ${brand.name} Models`}
            role="button"
            aria-label={brand.ariaLabel}
          >
            <div className="console-logo" style={logoContainerStyle}>
              {/* Render icon with Kentech medium gray color */}
              <brand.Icon size={60} style={{ color: '#6c757d' }} />
            </div>
            <h3 style={itemHeadingStyle}>{brand.name}</h3>
            <span style={itemTextStyle}>View Models & Repairs</span>
          </Link>
        ))}
      </div>

      {/* Additional Info Section */}
      <section className="console-extra-info" style={extraInfoStyle} aria-labelledby="console-info-heading">
        <h4 id="console-info-heading" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', marginBottom: '1rem', color: '#6c757d' }}>
          <FaWrench />
          Console Repair Experts
        </h4>
        <p>
            From disc drive issues to the 'Blue Light of Death', our technicians can diagnose and fix problems on PlayStation, Xbox, and Nintendo consoles.
        </p>
        <p style={{ marginTop: '1.5rem' }}>
          Have an older or different console?{' '}
          <Link to="/contact" style={contactLinkStyle}>
            Contact Us
          </Link>
        </p>
      </section>
    </main>
  );
}

export default ConsoleSelection;